import { render, staticRenderFns } from "./TeamPlayersTable.vue?vue&type=template&id=5c906864&scoped=true"
import script from "./TeamPlayersTable.vue?vue&type=script&lang=js"
export * from "./TeamPlayersTable.vue?vue&type=script&lang=js"
import style0 from "./TeamPlayersTable.vue?vue&type=style&index=0&id=5c906864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c906864",
  null
  
)

export default component.exports